import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../../api/api";
import NewCompanyList from "../../Work/new-company-list/NewCompanyList";
import OldCompanyList from "../../Work/old-company-list/OldCompanyList";
import OtherList from "../../Work/otherList/OtherList";
import CompanyEditModal from "./CompanyEditModal";

const CompanyList = () => {
  const [isActive, setIsActive] = useState(1);
  const [oldCompanyList, setOldCompanyList] = useState([]);
  const [viewMore, setViewMore] = useState(false);
  const [viewMore1, setViewMore1] = useState(false);
  const [otherCompanyList, setOtherCompanyList] = useState([]);
  const [newCompanyList, setNewCompanyList] = useState([]);
  const [companyId, setCompanyId] = useState(null);
  const [changes, setChanges] = useState(false);
  const [multipleCompanyList, setMultipleCompanyList] = useState([]);
  useEffect(() => {
    api
      .get(
        "/services/company/public-view/?company_type=private&is_existing_company=false"
      )
      .then((response) => {
        setNewCompanyList(response.data);
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  }, [changes]);
  useEffect(() => {
    api
      .get("/services/company/public-view/?company_type_not=private")
      .then((response) => {
        setOtherCompanyList(response.data);
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  }, [changes]);
  useEffect(() => {
    api
      .get(
        "/services/company/public-view/?is_existing_company=true&company_type=private "
      )
      .then((response) => {
        setOldCompanyList(response.data);
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  }, [changes]);
  useEffect(() => {
    api
      .get(`/services/company/`)
      .then((response) => {
        setMultipleCompanyList(response.data);
      })
      .catch((error) => {
        // toast.error("Something Went Wrong")
        console.log(error);
      });
  }, [changes]);

  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Company and Business List
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>
      {/* tab  */}
      <div className="mt-5 p-3 md:!p-10">
        <ul className="tabs border-primary-red m-0 grid list-none grid-cols-1 place-content-between gap-5 rounded-3xl border-2 p-3 md:grid-cols-2 lg:grid-cols-3">
          <li
            onClick={() => setIsActive(1)}
            data-tab-target="#first"
            className={`active tab text-primary-blue cursor-pointer rounded-full ${
              isActive === 1 ? " bg-red-600 text-white" : "bg-[#DFF1E7]"
            }  px-4 py-3 text-center font-bold`}
          >
            <p>New Company List</p>
            <p className="">नयाँ कम्पनीको सूची</p>
          </li>
          <li
            onClick={() => setIsActive(2)}
            className={`active tab text-primary-blue cursor-pointer rounded-full ${
              isActive === 2 ? " bg-red-600 text-white" : "bg-[#DFF1E7]"
            }  px-4 py-3 text-center font-bold`}
            data-tab-target="#second"
          >
            <p className="">Old Company List</p>
            <p className="">पुरानो कम्पनीको सूची</p>
          </li>
          <li
            onClick={() => setIsActive(3)}
            className={`active tab text-primary-blue cursor-pointer rounded-full ${
              isActive === 3 ? " bg-red-600 text-white" : "bg-[#DFF1E7]"
            }  px-4 py-3 text-center font-bold`}
            data-tab-target="#third"
          >
            <p>Other business List</p>
            <p>अन्य व्यवसायको सूची</p>
          </li>
        </ul>
        {/* tab contents */}
        <div className="tab-content mx-3">
          {isActive === 1 && (
            <>
              {/* first items */}
              <div id="first" data-tab-content="" className="active">
                {/* Single company list */}
                <h1 className="text-primary-red mt-10 font-bold underline">
                  Single Company List
                </h1>
                <div>
                  <h1 className="text-primary-red font-Acme text-xl mt-4 sm:mt-10 font-bold underline">
                    New Company List
                  </h1>
                  <div className="">
                    <div className="flex flex-col">
                      <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block md:w-full w-1 sm:px-6 lg:px-8">
                          {/* search */}

                          <table className="min-w-full border border-collapse table-fixed">
                            <thead className="font-Bree text-sm font-bold border-b bg-white">
                              <tr>
                                <th
                                  scope="col"
                                  className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                                >
                                  SN.
                                </th>
                                <th
                                  scope="col"
                                  className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                                >
                                  Company Name
                                </th>
                                <th
                                  scope="col"
                                  className="font-fold bg-primary-red px-6 py-4 text-left text-white"
                                >
                                  Address
                                </th>
                                <th
                                  scope="col"
                                  className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                                >
                                  Company Type
                                </th>
                                <th
                                  scope="col"
                                  className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                                >
                                  Darta Date
                                </th>
                                <th
                                  scope="col"
                                  className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                                >
                                  Darta No.
                                </th>
                                <th
                                  scope="col"
                                  className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                                >
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody className="font-Acme">
                              {newCompanyList
                                ?.slice(
                                  0,
                                  `${viewMore ? 10 : newCompanyList.length}`
                                )
                                .map((item, index) => {
                                  // console.log("new company List" ,item)
                                  return (
                                    <tr
                                      key={index}
                                      className="text-primary-blue font-Acme border-b bg-gray-100"
                                    >
                                      <td className="whitespace-nowrap px-6 py-4  font-medium">
                                        {index + 1}
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                        {item.company_name}
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                        {item.company_address}
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                        {item.company_type}
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                        {item.regd_date}
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                        {item.regd_number}
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                        <Link
                                        to="company-edit"
                                        state={
                                        {  companyListId:item,
                                        
                                          companyType:"New Company"}
                                        }
                                          // onClick={() => setCompanyId(item.id)}
                                          // data-bs-toggle="modal"
                                          // data-bs-target="#LinkModalDemo"
                                          className="bg-primary-blue  px-2 text-white rounded-2xl"
                                        >
                                          View /Edit
                                        </Link>
                                        {/* <CompanyEditModal
                                          companyListId={companyId}
                                          setChanges={setChanges}
                                          changes={changes}
                                          companyType="New Company"
                                        /> */}
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                          <div className="">
                            {viewMore ? (
                              <button
                                className="bg-primary-blue rounded-md px-5 py-3 font-bold text-white"
                                onClick={() => setViewMore(false)}
                              >
                                View More
                              </button>
                            ) : (
                              <button
                                className="bg-primary-blue rounded-md px-5 py-3 font-bold text-white"
                                onClick={() => setViewMore(true)}
                              >
                                View Less
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="">
                <div className="flex flex-col">
                  <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full sm:px-6 lg:px-8">
                      <div className="overflow-hidden">
                   
                        <div className="flex items-center justify-between">
                          <input
                            placeholder="Search by Branch"
                            type="search"
                            className="my-3 rounded-lg border border-black p-3"
                          />
                          <input
                            placeholder="Search by Company"
                            type="search"
                            className="my-3 rounded-lg border border-black p-3"
                          />
                          <input
                            placeholder="Search by Address"
                            type="search"
                            className="my-3 rounded-lg border border-black p-3"
                          />
                        </div>
                      </div>
                      <table className="min-w-full border">
                        <thead className="font-Bree border-b bg-white font-bold">
                          <tr>
                            <th
                              scope="col"
                              className="bg-primary-red px-6 py-4 text-left text-sm font-bold text-white"
                            >
                              SN.
                            </th>
                            <th
                              scope="col"
                              className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                            >
                              Company Name
                            </th>
                            <th
                              scope="col"
                              className="font-fold bg-primary-red px-6 py-4 text-left text-white"
                            >
                              Address
                            </th>
                            <th
                              scope="col"
                              className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                            >
                              Registered Date
                            </th>
                            <th
                              scope="col"
                              className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                            >
                              PAN No.
                            </th>
                            <th
                              scope="col"
                              className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                            >
                              Contact No.
                            </th>
                            <th
                              scope="col"
                              className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody className="font-Acme">
                          <tr className="text-primary-blue border-b bg-gray-100">
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-medium">
                              1
                            </td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light">
                              Intelzy
                            </td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light">
                              Private company
                            </td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light">
                              2022-2-23
                            </td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light">
                              435893
                            </td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light">
                              435893
                            </td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light">
                              <a
                                href="./company-details.html"
                                className="bg-primary-blue rounded-full py-1 px-2 text-white"
                              >
                                View and Edit
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div> */}
                {/* end single company list */}
                {/* Multiple company list */}
                <h1 className="text-primary-red mt-10 font-bold underline">
                  Multiple Company List
                </h1>
                <div className="">
                  <div className="flex flex-col">
                    <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="inline-block min-w-full sm:px-6 lg:px-8">
                        <div className="overflow-hidden">
                          {/* search */}
                          <div className="flex items-center justify-between">
                            <input
                              placeholder="Search by Branch"
                              type="search"
                              className="my-3 rounded-lg border border-black p-3"
                            />
                            <input
                              placeholder="Search by Company"
                              type="search"
                              className="my-3 rounded-lg border border-black p-3"
                            />
                            <input
                              placeholder="Search by Address"
                              type="search"
                              className="my-3 rounded-lg border border-black p-3"
                            />
                          </div>
                        </div>
                        <table className="min-w-full border">
                          <thead className="font-Bree border-b bg-white font-bold">
                            <tr>
                              <th
                                scope="col"
                                className="bg-primary-red px-6 py-4 text-left text-sm font-bold text-white"
                              >
                                SN.
                              </th>
                              <th
                                scope="col"
                                className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                              >
                                Company Name
                              </th>
                              <th
                                scope="col"
                                className="font-fold bg-primary-red px-6 py-4 text-left text-white"
                              >
                                Address
                              </th>
                              <th
                                scope="col"
                                className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                              >
                                Company Type
                              </th>
                              <th
                                scope="col"
                                className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                              >
                                Registered Date
                              </th>
                              <th
                                scope="col"
                                className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                              >
                                Registration No.
                              </th>

                              <th
                                scope="col"
                                className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody className="font-Acme">
                            {multipleCompanyList
                              ?.filter(
                                (value) => value.business_type === "bahul"
                              )
                              .slice(
                                0,
                                `${viewMore ? 10 : multipleCompanyList.length}`
                              )
                              .map((item, index) => {
                                console.log("newcompanyList", item);
                                return (
                                  <tr
                                    key={index}
                                    className="text-primary-blue border-b bg-gray-100"
                                  >
                                    <td className="whitespace-nowrap px-6 py-4 text-sm font-medium">
                                      {index + 1}
                                    </td>
                                    <td className="whitespace-nowrap px-6 py-4 text-sm font-light">
                                      {item.company_name}
                                    </td>
                                    <td className="whitespace-nowrap px-6 py-4 text-sm font-light">
                                      {item.company_address}
                                    </td>
                                    <td className="whitespace-nowrap px-6 py-4 text-sm font-light">
                                      {item.company_type}
                                    </td>
                                    <td className="whitespace-nowrap px-6 py-4 text-sm font-light">
                                      {item.regd_date}
                                    </td>
                                    <td className="whitespace-nowrap px-6 py-4 text-sm font-light">
                                      {item.regd_number}
                                    </td>
                                    <td className="whitespace-nowrap px-6 py-4 text-sm font-light">
                                      <button
                                        onClick={() => setCompanyId(item.id)}
                                        data-bs-toggle="modal"
                                        data-bs-target="#LinkModalDemo"
                                        className="bg-primary-blue  px-2 text-white rounded-2xl"
                                      >
                                        View /Edit
                                      </button>
                                      <CompanyEditModal
                                        companyListId={companyId}
                                        setChanges={setChanges}
                                        changes={changes}
                                        companyType="New Company"
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                            <div className="">
                              {viewMore1 ? (
                                <button
                                  className="bg-primary-blue rounded-md px-5 py-3 font-bold text-white"
                                  onClick={() => setViewMore1(false)}
                                >
                                  View More
                                </button>
                              ) : (
                                <button
                                  className="bg-primary-blue rounded-md px-5 py-3 font-bold text-white"
                                  onClick={() => setViewMore1(true)}
                                >
                                  View Less
                                </button>
                              )}
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        {/* second items */}
        {isActive === 2 && (
          <div className="">
            <h1 className="text-primary-red text-xl font-Acme mt-4 sm:mt-10 font-bold underline">
              Old Company List
            </h1>
            <div className="">
              <div className="flex flex-col">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block w-1 md:w-full sm:px-6 lg:px-8">
                    {/* search */}
                    <div className="flex items-center justify-start gap-5">
                      <input
                        placeholder="Search"
                        type="search"
                        className="my-3 rounded-lg border border-black p-3"
                      />
                    </div>

                    <table className="min-w-full border border-collapse table-fixed">
                      <thead className="font-Bree text-sm font-bold border-b bg-white">
                        <tr>
                          <th
                            scope="col"
                            className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                          >
                            SN.
                          </th>
                          <th
                            scope="col"
                            className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                          >
                            Company Name
                          </th>
                          <th
                            scope="col"
                            className="font-fold bg-primary-red px-6 py-4 text-left text-white"
                          >
                            Address
                          </th>
                          <th
                            scope="col"
                            className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                          >
                            Company Type
                          </th>
                          <th
                            scope="col"
                            className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                          >
                            Darta Date
                          </th>
                          <th
                            scope="col"
                            className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                          >
                            Darta No.
                          </th>
                          <th
                            scope="col"
                            className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className="font-Acme">
                        {oldCompanyList
                          ?.slice(0, `${viewMore ? 10 : oldCompanyList.length}`)
                          .map((item, index) => {
                            return (
                              <tr
                                key={index}
                                className="text-primary-blue font-Acme border-b bg-gray-100"
                              >
                                <td className="whitespace-nowrap px-6 py-4  font-medium">
                                  {index + 1}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                  {item.company_name}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                  {item.company_address}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                  {item.company_type}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                  {item.regd_date}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                  {item.regd_number}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                  <button
                                    onClick={() => setCompanyId(item.id)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#LinkModalDemo"
                                    className="bg-primary-blue  px-2 text-white rounded-2xl"
                                  >
                                    View /Edit
                                  </button>
                                  <CompanyEditModal
                                    companyListId={companyId}
                                    setChanges={setChanges}
                                    changes={changes}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    <div className="">
                      {viewMore ? (
                        <button
                          className="bg-primary-blue rounded-md px-5 py-3 font-bold text-white"
                          onClick={() => setViewMore(false)}
                        >
                          View More
                        </button>
                      ) : (
                        <button
                          className="bg-primary-blue rounded-md px-5 py-3 font-bold text-white"
                          onClick={() => setViewMore(true)}
                        >
                          View Less
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {isActive === 3 && (
          <div className="mt-10" id="third" data-tab-content="">
            <h1 className="text-primary-red font-Acme text-xl mt-10 font-bold underline">
              Others Business List
            </h1>
            <div className="">
              <div className="flex flex-col">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block w-1 md:w-full sm:px-6 lg:px-8">
                    {/* search */}
                    <div className="flex items-center justify-start gap-5">
                      <input
                        placeholder="Search"
                        type="search"
                        className="my-3 rounded-lg border border-black p-3"
                      />
                    </div>
                    <table className="min-w-full border border-collapse table-fixed">
                      <thead className="font-Bree text-sm font-bold border-b bg-white">
                        <tr>
                          <th
                            scope="col"
                            className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                          >
                            SN.
                          </th>
                          <th
                            scope="col"
                            className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                          >
                            Company Name
                          </th>
                          <th
                            scope="col"
                            className="font-fold bg-primary-red px-6 py-4 text-left text-white"
                          >
                            Address
                          </th>
                          <th
                            scope="col"
                            className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                          >
                            Company Type
                          </th>
                          <th
                            scope="col"
                            className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                          >
                            Darta Date
                          </th>
                          <th
                            scope="col"
                            className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                          >
                            Darta No.
                          </th>
                          <th
                            scope="col"
                            className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className="font-Acme">
                        {otherCompanyList
                          ?.slice(
                            0,
                            `${viewMore ? 10 : otherCompanyList.length}`
                          )
                          .map((item, index) => {
                            return (
                              <tr
                                key={index}
                                className="text-primary-blue font-Acme border-b bg-gray-100"
                              >
                                <td className="whitespace-nowrap px-6 py-4  font-medium">
                                  {index + 1}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                  {item.company_name}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                  {item.company_address}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                  {item.company_type}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                  {item.regd_date}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                  {item.regd_number}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                                  <button
                                    data-bs-toggle="modal"
                                    onClick={() => setCompanyId(item.id)}
                                    data-bs-target="#LinkModalDemo"
                                    className="bg-primary-blue  px-2 text-white rounded-2xl"
                                  >
                                    View /Edit
                                  </button>
                                  <CompanyEditModal
                                    companyListId={companyId}
                                    setChanges={setChanges}
                                    changes={changes}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    <div className="w-full">
                      {viewMore ? (
                        <button
                          className="bg-primary-blue border-none rounded-md px-5 py-3 font-bold text-white"
                          onClick={() => setViewMore(false)}
                        >
                          View More
                        </button>
                      ) : (
                        <button
                          className="bg-primary-blue border-none rounded-md px-5 py-3 font-bold text-white"
                          onClick={() => setViewMore(true)}
                        >
                          View Less
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyList;
